export default __webpack_public_path__ + "747f60723cedff9861b3b9b3b82abd72.svg";